var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * PackingV2 Component
 */
import React, { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import MainHeading from '../MainHeading';
import { usePackingState, usePrinterConnection } from './hooks';
import { ShipmentList, ShipmentScanner } from './shipment';
import PackingManager from './packing/PackingManager';
var PackingV2 = function (_a) {
    var setIsLoading = _a.setIsLoading;
    var t = useTranslation().t;
    var _b = usePackingState(), currentSubscreen = _b.currentSubscreen, loading = _b.loading, loadInitialData = _b.loadInitialData
    // resetState
    ;
    // Initialize printer connection on mount
    var _c = usePrinterConnection(), connectPrinter = _c.connectPrinter, disconnectPrinter = _c.disconnectPrinter;
    // Connect printer on mount
    useEffect(function () {
        connectPrinter();
        return function () {
            disconnectPrinter();
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    // Sync loading state with parent
    useEffect(function () {
        // Reduce dim, only show it when shipment is loading
        var shouldShowGlobalOverlay = loading.shipment; // isAnyLoading && !loading.packItem
        setIsLoading === null || setIsLoading === void 0 ? void 0 : setIsLoading(shouldShowGlobalOverlay);
    }, [loading.shipment, setIsLoading]);
    // Load initial reference data on mount
    useEffect(function () {
        loadInitialData();
    }, [loadInitialData]);
    // Cleanup on unmount
    useEffect(function () {
        return function () {
            // Don't reset state on unmount to preserve state during navigation
            // resetState()
        };
    }, []);
    var wrapWithClassicHeading = useCallback(function (children) {
        return (_jsxs("div", __assign({ className: "px-4 sm:px-8 lg:px-5 pt-1 lg:pt-3 pb-16 sm:w-4/5 w-11/12 lg:w-" + (currentSubscreen === 'shipmentId' ? '2/5' : '11/12') + " mx-auto" }, { children: [_jsx(MainHeading, { heading: t('Packing') }, void 0), _jsx("div", __assign({ className: 'flex-1 overflow-hidden' }, { children: children }), void 0)] }), void 0));
    }, [currentSubscreen, t]);
    // Render based on current subscreen
    var renderContent = function () {
        switch (currentSubscreen) {
            case 'shipmentId':
                return wrapWithClassicHeading(_jsx(ShipmentScanner, {}, void 0));
            case 'shipmentList':
                return wrapWithClassicHeading(_jsx(ShipmentList, {}, void 0));
            case 'scanProduct':
                return _jsx(PackingManager, {}, void 0);
            default:
                return _jsx(ShipmentScanner, {}, void 0);
        }
    };
    return _jsx("div", __assign({ className: 'h-screen w-full overflow-hidden font-inter' }, { children: renderContent() }), void 0);
};
export default PackingV2;
